/* eslint-disable react-doctor/no-inline-exhaustive-style */
import type { CSSProperties } from "react";

interface KbdProps {
  children: React.ReactNode;
  className?: string;
  /**
   * Merged over the §02.5 defaults below — for call sites that need a
   * narrower single-character key (width/padding) or a smaller inline
   * variant (height/fontSize), without forking the primitive. The border,
   * radius and colour tokens that make this "the" key cue stay fixed.
   */
  style?: CSSProperties;
}

export function Kbd({ children, className, style }: KbdProps) {
  return (
    // eslint-disable-next-line react-doctor/no-inline-exhaustive-style
    // §02.5 measurements: 24 min-width, 24 height, border 1px with a 2px
    // bottom edge (the "key" cue), radius-0 (read, not pressed — §17.2).
    <span
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 24,
        height: 24,
        padding: "0 6px",
        borderRadius: 0,
        background: "var(--tls-surface-elevated)",
        borderStyle: "solid",
        borderColor: "var(--tls-border-strong)",
        borderWidth: "1px 1px 2px 1px",
        color: "var(--tls-fg-strong)",
        fontFamily: "var(--tls-font-body)",
        fontVariantNumeric: "tabular-nums",
        // eslint-disable-next-line react-doctor/no-tiny-text
        // §15.2: REM category — 11.5px at the 16px reference root.
        fontSize: "0.71875rem",
        fontWeight: 700,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
